import appointment from './appointment';
import customer from './customer';
import customerVer2 from './customer-ver2';

export default {
  appointment,
  customer,
  customerVer2,
};
